import OkC from "shared/util/OkcApi";
import { ERRORS } from "apps/photo_upload/util/constants";

/*
 * Convert a back-end error message to a human readable one.
 *
 * @param {string} error - the backend code (e.g., E_FILE_TOO_SMALL)
 * @returns {string} message - the human readable code (e.g., "Dat file too
 *   small yo")
 */
function getPhotoError(err) {
	if (ERRORS[err]) {
		return ERRORS[err].desc;
	} else {
		return ERRORS.DEFAULT.desc;
	}
}


/*
 * Upload a photo to the server
 *
 * @param {file} file - The photo file that comes from a file input
 * @param {string} userid - The user's id
 * @param {function} [successCb] - A function to run on success
 * @param {function} [failureCb] - A function to run on failure
 */
export function uploadPhotoFile(file, userid, successCb, failureCb) {
	if (!file) {
		return;
	}

	const data = new FormData();
	data.append("file", file);
	data.append("userid", userid);
	data.append("okc_api", 1);

	OkC.legacy("/ajaxuploader", {
		type: "POST",
		data,

		success(res) {
			if (res.error) {
				if (typeof (failureCb) === "function") {
					failureCb(getPhotoError(res.error));
				}

				return;
			}

			if (typeof (successCb) === "function") {
				successCb({
					picid: res.id,
					width: res.width,
					height: res.height,
					src: res.url,
					thumb: res.thumb_url,
				});
			}
		},

		error(err) {
			if (typeof (failureCb) === "function") {
				failureCb(err);
			}
		},
	});
}


/*
 * Read a file using the FileReader api, and return the src, witdh, and height
 * in a passed callback function.
 *
 * This works by reading the image, then loading the resultant source into a
 * temporary Image object to get the dimensions.
 *
 * @param {file} file - the data from a file input (i.e., e.target.files[0])
 */
export function loadFileLocally(file, successCb = false, failureCb = false) {
	const imageType = /image.*/;

	if (!file.type.match(imageType)) {
		if (typeof (failureCb) === "function") {
			failureCb();
		}
	}

	const reader = new FileReader();

	reader.onload = () => {
		const img = new Image();

		img.onload = () => {
			if (typeof (successCb) === "function") {
				successCb({
					src: reader.result,
					width: img.width,
					height: img.height,
				});
			}
		};

		img.src = reader.result;
	};

	reader.readAsDataURL(file);
}



// WEBPACK FOOTER //
// ./src/apps/photo_upload/util/web.js